import { Fragment, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { NavLink, PanelDropdown, Scroller } from "../../../components";
import { IOutlinerContext } from "../../../context";
import { IOutliner } from "../../../interface";
import { Viewport } from "../../../lib";

import "./style.scss";

type ViewerState = {
    visible: boolean;
};

type Props = {
    viewport: Viewport;
    loading: boolean;
    isMobile: boolean;
    outliner: IOutlinerContext;
};

export const NavPanel = ({ isMobile, outliner }: Props) => {
    const [obj, setObj] = useState<IOutliner | null>(null);
    const [open, setOpen] = useState<boolean>(false);
    const [params] = useSearchParams();

    useEffect(() => {
        if (params) {
            const query = Boolean(params.get("menu") || false);

            setOpen(query);
        }
    }, [params, setOpen]);

    return outliner.model ? (
        <PanelDropdown
            icon="apps"
            className="nav-panel"
            title="Projects"
            selected={outliner.model}
            isMobile={isMobile}
            isOpen={open}
        >
            <Scroller className="nav-scroller" scrollTo={`cat_${obj?.id}`}>
                {outliner.models.map((item, i) => {
                    return (
                        <Fragment key={i}>
                            <NavLink
                                id={`cat_${obj?.id}`}
                                variant="outliner"
                                href={`/Projects/${String(item.name)}`}
                                icon="blender"
                                active={obj?.id === item.id}
                                text={item.name}
                                onClick={(e) => {
                                    setObj(item);

                                    if (obj?.id === item.id) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Fragment>
                    );
                })}
                <hr className="hr" />
                <NavLink
                    id={`cat_${obj?.id}`}
                    variant="outliner"
                    href={`/`}
                    icon="home-5"
                    text={"Home"}
                    onClick={(e) => {
                        setObj(null);
                    }}
                />
            </Scroller>
        </PanelDropdown>
    ) : null;
};
